import 'regenerator-runtime/runtime.js';
import { useState } from 'react';
import useAxiosSubmit from './useAxiosSubmit';

const useSendMemberText = () => {
  const [memberTextData, setMemberTextData] = useState();
  const [url, setUrl] = useState();
  const { response, isLoading, hasErrored } = useAxiosSubmit(url, memberTextData);

  const sendMemberText = async (request) => {
    setUrl(`${process.env.API_BASE_URL}/v1/notification-requests/user`);
    setMemberTextData(request);
  };

  return { response, error: hasErrored, isPending: isLoading, sendMemberText };
};

export default useSendMemberText;
